import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

export interface FileEvent {
  id: string;
  traceId: string;
  clientId: number;
  subDomain: string;
  filename: string;
  fromPath: string;
  toPath: string;
  direction: string;
  operationType: string;
  provider: string;
  syncPairId: string;
  timestamp: string;
  errorCode: Nullable<string>;
  errorDetails: Nullable<string>;
}

export enum InfoDataType {
  FILESYSTEM = 'filesystem',
  CHIPS = 'chips',
  USER_ACTIVITY = 'user-activity',
  TEXT = 'text',
  CONTENT = 'content',
}

export interface ErrorsLog {
  count: number;
  results: FileEvent[];
}

export interface ConfigurationPanelProps {
  config: SyncPairConfig;
  isError: boolean;
  isLoading: boolean;
  tab: string;
  onHide: () => void;
  errors?: ErrorsLog;
}

export interface StorageProviderOptions {
  apiKey: string;
  importFile?: string;
  location: string;
  mapping?: any[];
  streamPosition: number;
  syncDelaySeconds: number;
  tokens: Token[];
  syncType?: string;
  file?: File;
  extraContext?: object;
  updatedBy?: number;
}

export interface SyncPairConfigInfo {
  id: string;
  allowedSyncFileTypes: string[];
  createdBy: PilotId;
  dateCreated: string;
  name: string;
  dateUpdated: string;
  evisortFolderPath: string;
  provider: string;
  providerOptions: StorageProviderOptions;
  tokenId?: string;
  skipEmptyFolders?: boolean;
  providerPrefix: string;
  providerFolderPath?: string;
}

export interface SyncPairConfig extends SyncPairConfigInfo {
  name: string;
  title: string;
}
export interface Token {
  apiKey: string;
  tokenType: string;
  tokenId: string;
  version: string;
}
